module.exports = __webpack_public_path__ + "img/aplikacja_bankowa.ca6fd93a.png";